import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button, { ButtonTypes } from "../../../common/components/button/button";
import { useLoadHandler } from "../../../common/customHooks/useLoadHandler";
import { LoadingStatus } from "../../../common/enums/loadingStatus";
import { QuestionTypes } from "../../../common/enums/questionTypes";
import { CampaignApi } from "../../../common/services/api/campaignApi";
import { Color } from "../../../common/style/colors";
import CampaignResultLayout from "../components/campaignResultLayout/campaignResultLayout";
import CampaignResultSkeleton from "../components/campaignResultSkeleton/campaignResultSkeleton";
import ChartArea from "../components/chartArea/chartArea";
import ShortAnswerArea from "../components/shortAnswerArea/shortAnswerArea";
import { CampaignResultModel } from "../models/campaignResultModel";
import "./campaignResultPage.scss";

export default function CampaignResultPage() {
  const navigate = useNavigate();
  const [campaignResult, setCampaignResult] = useState<CampaignResultModel>(
    {} as CampaignResultModel
  );

  const { loadingStatus, callFetchAsync } = useLoadHandler(
    async (id: string) => {
      let result = await CampaignApi().campaignResult(id);
      return () => setCampaignResult(result);
    }
  );

  const { loadingStatus: csvLoadingStatus, callFetchAsync: callCsvFetchAsync } =
    useLoadHandler(async (id: string) => {
      let result = await CampaignApi().downloadResult(id);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);
      link.click();
    });

  useEffect(() => {
    let id = new URLSearchParams(window.location.search).get("id");
    if (id) callFetchAsync(id);
  }, []);

  return (
    <CampaignResultLayout
      title={campaignResult.title}
      decription={campaignResult.description}
    >
      <div className="back-button-container">
        <div
          className="back-button"
          onClick={() => navigate("/home")}
          style={{ cursor: "pointer" }}
        >
          {"< Back"}
        </div>
        <Button
          type={ButtonTypes.OUTLINED}
          loadingStatus={csvLoadingStatus}
          loadSpinColor={Color().primaryColor}
          text={"Download CSV"}
          onClick={() =>
            callCsvFetchAsync(
              new URLSearchParams(window.location.search).get("id")
            )
          }
        />
      </div>
      <div className="campaign-result-title-container">
        <h3>Result</h3>
        <p style={{ fontSize: "12px" }}>{`(${
          campaignResult.totalResult ?? 0
        } responses)`}</p>
      </div>
      {loadingStatus === LoadingStatus.SUCCESS ? (
        <>
          {campaignResult.results?.map((e, i) => {
            switch (e.questionType) {
              case QuestionTypes.SHORT_ANSWER:
                return (
                  <ShortAnswerArea
                    key={i}
                    title={e.questionTitle}
                    answers={e.answers?.map((e) => e.option ?? "")}
                  />
                );
              default:
                return (
                  <ChartArea
                    key={i}
                    questionTitle={e.questionTitle}
                    labels={e.answers?.map((e) => e.option ?? "")}
                    data={e.answers?.map((e) => e.value ?? 0)}
                  />
                );
            }
          })}
        </>
      ) : (
        <>
          <CampaignResultSkeleton />
          <CampaignResultSkeleton />
        </>
      )}
    </CampaignResultLayout>
  );
}
